import { useCustomInfiniteScroll } from './_hooks/useCustomInfiniteScroll';

export function AlgoliaInfiniteScroll({ hitComponent: HitComponent, className }) {
	const { hits, sentinelRef } = useCustomInfiniteScroll();

	return (
		<ul className={`ais-InfiniteHits ${className || ''}`}>
			{hits.map(hit => (
				<li key={hit.objectID} className='ais-InfiniteHits-item'>
					<HitComponent hit={hit} />
				</li>
			))}
			<li className='ais-InfiniteHits-sentinel' ref={sentinelRef} aria-hidden='true' />
		</ul>
	);
}
